import React from "react";
import _ from "lodash";
import { Card, Dropdown, Switch, Row, Col, Table, Menu, Tag, Button, Collapse, Tooltip } from "antd";
import { withRouter } from "react-router";
import { DownOutlined, EditOutlined, CopyOutlined, PlayCircleOutlined, FieldTimeOutlined } from "@ant-design/icons";
import AppBreadcrumb from 'components/AppBreadcrumb';
import { BASE_PADDING } from "constants/Layout";
import PolicyAPI, { PolicyEnvAPI } from "restAPI/PolicyAPI";
import { showAPIError } from "restAPI";
import { Link } from "react-router-dom";
import ReportsAPI from "restAPI/ReportsAPI";
import AppLoader from "components/AppLoader";
import { CellRenderers } from "utils/tableUtils";
import ModalUtil from "utils/modalUtil";
import ConfirmPopup from "components/ConfirmPopup";
import DeleteButton from "components/DeleteButton";
import HistoryPopup from './HistoryPopup';
import Vocabulary from 'components/Vocabulary';
import { HelpIcon } from "components/Icons";
import { withGlobalFilterContext } from 'contexts/GlobalFilterContext';
import { withActiveUser } from "contexts/ActiveUserContext";
import AuthorisedContainer from 'components/AuthorisedContainer';
import { PermissionSetMap } from 'constants/RBACConstants';
import AuthorisedSwitch from "components/AuthorisedSwitch";
import message from "components/CustomMessage";
import ContentOverlay from "components/ContentOverlay";
import { withFeatureFlags } from 'contexts/FeatureFlagContext';
import ComparisonModal from "views/CustomPolicy/ComparisonModal";
import { MarkdownFormatter } from "components/MarkupFormatter";
import SubProductAPI from "restAPI/SubProductAPI";
import ACSeverityTag from "ac-components/ACSeverityTag";
const {Panel} = Collapse;

const RULE_TYPE = {
    Automatic: "Automatic",
    Manual: "Manual",
    Not_Applicable: "Not Applicable",
    Exception: "Excception",
}

export function SeverityDropDown({ onSelect, severity, disabled = false, isCustomized = false }) {
    const menu = (
        <Menu onClick={onSelect}>
            <Menu.Item key="critical">
                <ACSeverityTag value={"Critical"} isCustomizedValue={isCustomized} />
            </Menu.Item>
            <Menu.Item key="high">
            <ACSeverityTag value={"High"} isCustomizedValue={isCustomized} />
            </Menu.Item>
            <Menu.Item key="medium">
            <ACSeverityTag value={"Medium"} isCustomizedValue={isCustomized} />
            </Menu.Item>
            <Menu.Item key="low">
            <ACSeverityTag value={"Low"} isCustomizedValue={isCustomized} />
            </Menu.Item>
            <Menu.Item key="info">
            <ACSeverityTag value={"Info"} isCustomizedValue={isCustomized} />
            </Menu.Item>
        </Menu>
    )
    return (
        <Dropdown
            disabled={disabled}
            // o={onSelect}
            overlay={menu}
            trigger={['click']}
        >
            <span className="d-flex align-items-center">
                {<ACSeverityTag value={severity} isCustomizedValue={isCustomized} className="text-ellipsis" />}
                &nbsp;
                <DownOutlined />
            </span>
        </Dropdown>
    )
}

class Policy extends React.Component {
    constructor(props) {
        super(props);
        this.policyTimerId = null;
        this.state = {
            policy: null,
            editIndex: null,
            editedData: null,
            loading: true,
            activeKeys: [],
            keys: [],
            note: '',
            popupData: {},
            policyHistory: {}
        }
        this.columns = [
        {
            title: "CWE",
            dataIndex: "cwe",
            width: 120,
            render:(cwe,data)=> <ComparisonModal column={cwe} data={data} />,
        },
        {
            title: <>AMC Rule <Tooltip placement="right" title="ArmorCode rule x.y.z where x is the main category, y is the sub-category and z is the rule id inside this category/ sub-category." ><HelpIcon /></Tooltip></>,
            dataIndex: "ruleKey",
            width: 120,
            render:(ruleKey,data)=> <ComparisonModal column={ruleKey} data={data} />,
        }, {
            title: "Title",
            dataIndex: "name",
            width: 285,
            render: (title) => {
                return title ? <ContentOverlay content={title} minHeight={40}/>: 'N/A'
            },
        }, {
            title: "Control Id",
            dataIndex: "controlId",
            width: 80,
            render: CellRenderers.VALUE_OR_NA

        }, {
            title: <Vocabulary name="severity" />,
            dataIndex: "severity",
            render: (text, original, index) => {
                const { editIndex, editedData } = this.state;
                if (index === editIndex) {
                    return (
                        <SeverityDropDown
                            severity={editedData.severity}
                            onSelect={({ key }) => {
                                console.log(key)
                                this.setState(({ editedData }) => ({
                                    editedData: {
                                        ...editedData,
                                        severity: key
                                    }
                                }))
                            }}
                        />
                    )
                }
                return (
                    <Tag className={`${original.severity?.toLowerCase()} severity-width`}>{original.severity}</Tag>
                )
            },
            style: { overflow: "visible" },
            width: 150,
        }, 
        {
            title: "Rule Type",
            dataIndex: "ruleType",
            width: 94,
            render: (text) => RULE_TYPE[text]
        },
        {
            title: <>Note <Tooltip placement="right" title="When Rule Type is modified, note is displayed" ><HelpIcon /></Tooltip></>,
            dataIndex: 'note',
            width: 75,
            render: CellRenderers.VALUE_OR_NA
        },
        {
            title: <><Vocabulary name={"exception"} /> Time</>,
            dataIndex: "exceptionType",
            width: 106,
            render: CellRenderers.VALUE_OR_NA
        },
        {
            title: "Reference Doc",
            dataIndex: "referenceControlDoc",
            width: 106,
            render: CellRenderers.VALUE_OR_NA
        },
        ];

        _.bindAll(this, "onPolicyDelete", "showEnableDisablePopup", "updatePolicy")
    }
    componentDidMount() {
        this.fetchPolicy();
    }
    componentDidUpdate(prevProps) {
        const { globalFilterContext: { globalFilterHash: prevGlobalFilterHash } } = prevProps;
            const { globalFilterContext: { globalFilterHash } } = this.props;
            if (prevGlobalFilterHash !== globalFilterHash ) {
                this.props.history.goBack();
            }
      }

    getAllKeys(policy) {
        const keys = [];
        if(!_.isEmpty(policy.categories)){
            policy.categories.forEach((obj, i) => {
                keys.push(`${obj.name}-${i}`); 
                keys.push(...this.getAllKeys(obj))
            });
        } else if(!_.isEmpty(policy.rules)) {
            policy.rules.forEach((obj, i) => {
                keys.push(`${obj.name}-${i}`); 
                obj.key = `${obj.name}-${i}`;
            })
        }
        return keys;
    }
    async fetchPolicy() {
        const { policyId } = this.props.match.params;
        PolicyAPI.getEvents(policyId).then(res => this.setState({policyHistory: res}));
        try {
            const policy = await PolicyAPI.get(policyId).promise;
            let products = []
            if(policy.policyType === "CUSTOMER") {
                const {data} = await PolicyEnvAPI.get(policyId);
                products = data
            }
            const keys = this.getAllKeys(policy);
            this.setState({ policy, loading: false, products, keys });
        } catch(e) {
            console.error(e);
        }
    }
    async updatePolicy() {
        const { policy, popupData, note } = this.state;
        try {
            const p = await PolicyAPI.update(policy.id, {enabled: popupData.enabled, note})
            this.setState({policy: p, popupData: {}, note: ''})

        } catch (e) {
            showAPIError(e)
            this.setState({ popupData: {}, note: ''})
        }
    }

    showEnableDisablePopup(enabled) {

        const {policy} = this.state;
        const newPolicy = {...policy}
        const enableText = enabled ? 'Enable' : 'Disable';

        ModalUtil.show({
            content: <ConfirmPopup
                okText={enableText}
                type={null}
                title={`Are you sure you want to ${enableText} ${policy.name}?`}
                onOk={async (note) => {
                    try {
                        await PolicyAPI.update(policy.id, {enabled, note})    

                        // Update state
                        newPolicy.enabled = enabled
                        this.setState({policy: newPolicy})
                    } catch (error) {
                        console.error(error);
                    }
            }} note />
        })
    }

    showHistoryPopup() {
        const {policy, policyHistory} = this.state;
        ModalUtil.show({
            content: <HistoryPopup policyName={policy.name} data={policyHistory?.changes} />
        });
    }

    async onPolicyDelete(id) {
        try {
            await PolicyAPI.delete(id)
            message.success("Policy deleted successfully")
            this.props.history.push('/compliance')

        } catch (err) {
            console.log(err);
        }
    }
    async onPolicyRunDemand(policy,products) {
        const envs =[];
         products.forEach(async product => {
            let { appIds } = product;
            const { envId, envName, productId } = product; 
            if(product.isAllProducts){
                SubProductAPI.getAllQuick().promise.then(async (res)=>{
                    appIds = res.map(sp => sp.id);
                    appIds.forEach(subproductId =>{
                        envs.push({
                            productId,
                            subproductId: subproductId,
                            envId: envId || 0,
                            envName
                        })
                    })
                    try {
                        const isAllProducts = envs.some(env => env.productId === -3) ? true: false;
                        await ReportsAPI.post(policy.id,envs, isAllProducts)
                        message.success("Assessment is being created, it may take some time.");
                    } catch(e) {
                        console.error(e);
                    }
                });
            }else{
                appIds.forEach(subproductId =>{
                    envs.push({
                        productId,
                        subproductId: subproductId,
                        envId: envId || 0,
                        envName
                    })
                })
                try {
                    const isAllProducts = envs.some(env => env.productId === -3) ? true: false;
                    await ReportsAPI.post(policy.id,envs, isAllProducts)
                    message.success("Assessment is being created, it may take some time.");
                } catch(e) {
                    console.error(e);
                }
            }
         })
    }

    handleAccordion =(e) => {
        const {keys} = this.state;
        const remainingKeys = [...keys];
        if(e) {
            this.policyTimerId = setInterval(() => {
                const state = {};
                if(keys.length) {
                    state.activeKeys = [ ...this.state.activeKeys, ...remainingKeys.splice(0, 5)]
                }
                this.setState(state)
                if(_.isEmpty(remainingKeys)) {
                    clearInterval(this.policyTimerId)
                }
            }, 300);
        }else {
            clearInterval(this.policyTimerId)
            this.setState({activeKeys: []})
        }
    }

    renderPanelHeader = (cat) =>{
        const name = <MarkdownFormatter markdown={cat.name}/>
        if(cat.description){
           return <> {name} - {cat.description} </>
        }
        else{
           return name
        }
    }

    // Recursive rendering of rules & categories
    // If there are no rule & categories are there, This will call itself
    renderCategories = (categories, level, rules) => {
        const {activeKeys} = this.state;
        // Remove CWE column if policy is type of CWE Top 25
        const columns = this.columns;
        return <>
                    <Collapse onChange={(e) => this.setState({activeKeys: e})} activeKey={activeKeys}>
                {
                    categories.length ? categories.map((cat, i) => 
                            <Panel header={this.renderPanelHeader(cat)} key={`${cat.name}-${i}`}>  
                                { 
                                    cat.categories?.length ? 
                                    this.renderCategories(cat.categories, level+ 1, cat.rules) :
                                    <Table
                                    className="policy-table"
                                    dataSource={cat.rules}
                                    columns={columns}
                                    scroll={true}
                                    pagination={{
                                        hideOnSinglePage: true
                                    }}                  
                                    expandedRowKeys={activeKeys}              
                                    expandable={{
                                        expandedRowRender: record => renderRowExpand(record.description),
                                        rowExpandable: record => Boolean(record.description)
                                    }}
                                    onExpandedRowsChange={keys => this.setState({activeKeys: keys})}
                                />
                                }
                            </Panel>
                    ) : null
                }
                </Collapse>
                {
                    rules?.length 
                        ? <Table
                            className="policy-table"
                            dataSource={rules}
                            columns={columns}
                            scroll={true}
                            expandable={{
                                expandedRowRender: record => renderRowExpand(record.description),
                                rowExpandable: record => Boolean(record.description)
                            }}
                            expandedRowKeys={activeKeys}
                            onExpandedRowsChange={keys => this.setState({activeKeys: keys})}
                        /> : null
                }
            </>
    }

    renderSubProducts(subproduct){
        return subproduct.map((subProd, i) => <><span>{subProd}</span>{i !== subproduct.length - 1 ? ', ' : ''}</>)
    }

    render() {
        const { policy, loading, products, policyHistory } = this.state;
        const type = policy?.policyType?.toLowerCase();
        const spEnvMap = {}
        products && products.forEach(item => {
            spEnvMap.hasOwnProperty(item.appName) ? spEnvMap[item.appName].push(item.envName) : spEnvMap[item.appName] = [item.envName];
        })
        return (
            <div className='container'>
                {
                    loading
                    ?
                    <AppLoader />
                    :
                    <>
                        <AppBreadcrumb crumbs={[{text :"Policies", to : '/compliance'}, {text: type === 'customer' ? "Assessments" : "Policies", to: `/compliance/${type}`} ,`${policy.name}`]} />
                        <Row gutter={[BASE_PADDING, BASE_PADDING]}>
                            <Col sm={24}>
                                <Card size="small">
                                    <Row>
                                        <Col md={6}>
                                            Name: {policy.name}
                                        </Col>
                                        <Col md={6}>
                                            Tag: { Array.isArray(policy.tags) ? policy.tags.join(', ') : policy.tags }
                                        </Col>
                                        {type !== "system" && 
                                            <Col md={3}>
                                                Enable: <AuthorisedSwitch permission={PermissionSetMap.UPDATE_POLICY} size="small" name="enabled" onChange={this.showEnableDisablePopup} checked={policy.enabled} />
                                            </Col>
                                         }
                                        <Col md={type === "customer" ? 6 : 9}>
                                            Author: {policy.createdBy}
                                        </Col>
                                        {
                                            
                                            <Col md={3} style={{textAlign: 'right'}} >
                                                {
                                                    type === "customer" && 
                                                    <AuthorisedContainer permission={PermissionSetMap.CREATE_REPORT} tooltip={"Run on Demand"}>
                                                        <Button
                                                            type="link"
                                                            disabled={!policy.enabled}
                                                            size="small"
                                                            onClick={this.onPolicyRunDemand.bind(this, policy,products)}
                                                        >
                                                            <span ><PlayCircleOutlined /></span>
                                                        </Button>
                                                    </AuthorisedContainer>
                                                }
                                                <AuthorisedContainer permission={PermissionSetMap.WRITE_POLICY} tooltip="Copy & Customize Policy">
                                                    <Button
                                                        disabled={!policy.enabled}
                                                        type="link"
                                                        size="small"
                                                    >
                                                        <Link to={`/compliance/policies/${policy.id}/copy`}>
                                                            <CopyOutlined />
                                                        </Link>
                                                    </Button>
                                                </AuthorisedContainer>
                                                {type === 'customer' &&
                                                    <Tooltip title= {_.isEmpty(policyHistory?.changes) ? "No history available" : "View history"}>
                                                        <Button type="link" size="small" onClick={this.showHistoryPopup.bind(this)} disabled={_.isEmpty(policyHistory?.changes)}>                                                      
                                                            <FieldTimeOutlined />
                                                        </Button>
                                                    </Tooltip>
                                                }
                                                {type === "customer" &&
                                                <>
                                                    <AuthorisedContainer permission={PermissionSetMap.UPDATE_POLICY} tooltip="Edit">
                                                            <Button
                                                                type="link"
                                                                size="small"
                                                                disabled={!policy.enabled}
                                                            >
                                                            <Link to={`/compliance/policies/${policy.id}/edit`}>
                                                                <EditOutlined />
                                                            </Link>
                                                        </Button>
                                                    </AuthorisedContainer>
                                                    <AuthorisedContainer permission={PermissionSetMap.DELETE_POLICY} tooltip="Delete">
                                                        <DeleteButton onDelete={() => this.onPolicyDelete(policy.id)} promptMessage={`You want to delete policy ${policy.name}?`} confirmText={'Delete'} />
                                                    </AuthorisedContainer>
                                                </>}
                                            </Col>
                                        }
                                    </Row>
                                    {!_.isEmpty(products) &&
                                        <Row>
                                            <Col md={24}>
                                                <Row>
                                                    {products.map(({ productName:product, appNames:subProduct,envName:environment, isAllProducts}) => <>
                                                        <Col md={8}><Vocabulary name="product" />: {isAllProducts ? "All" : product}</Col>
                                                        <Col md={8}><Vocabulary name="subProduct" />: {isAllProducts ? "All" : this.renderSubProducts(subProduct)}</Col>
                                                        <Col md={8}>Environment: {environment}</Col>
                                                    </>)}
                                                </Row>
                                            </Col>
                                        </Row>
                                    }
                                </Card>

                            </Col>
                            <Col sm={24} style={{textAlign: 'right'}} >
                                Expand All <Switch  size="small" onChange={(e) => this.handleAccordion(e)}/>
                            </Col>
                            <Col sm={24}>
                                <Card size="small">
                                    {this.renderCategories(policy.categories, 0, policy.rules)}
                                </Card>
                            </Col>
                        </Row>
                        </>
                }
            </div>
        )
    }
}

export default withFeatureFlags(
    withGlobalFilterContext(
        withActiveUser(
            withRouter(
                Policy
            )   
        )
    )
  );

export const renderRowExpand = (description) => {
    return (
        <p style={{ margin: 0, paddingLeft: '48px'}}>
          <ContentOverlay content={<MarkdownFormatter markdown={description} />} minHeight={60}/>
       </p>

    )
}